/**
 * Writes WA-style title/escrow sales tax into buyer closingCostsMeta rows.
 * Row indices differ by template (e.g. 8/9 vs 9/10 for Metro United).
 * 
 * // For the Buyer’s module, the sales tax is calculated for the LP and half of the Escrow total, since it is split. So using your example below, Sales Tax - Title line item should show $89.50 on the Buyer’s module.


 */
export function applyWaSalesTaxClosingCosts(
  prev,
  {
    escrowSettlementAmount,
    lendersTitleAmount,
    salesTaxRate,
    lenderRowIndex = 11,
    escrowTaxRowIndex = 12,
  }
) {
  const rate = Number(salesTaxRate) || 0;
  if (rate === 0) return prev;

  const escrowAmount = Number(escrowSettlementAmount) || 0;
  const lenderAmount = Number(lendersTitleAmount) || 0;
  const taxEscrow = escrowAmount * rate;
  const taxLender = lenderAmount * rate;

  const source = prev?.closingCostsMeta;
  const closingCostsMeta = Array.isArray(source)
    ? [...source]
    : { ...(source ?? {}) };

  const fmtLender = (Number(taxLender) || 0).toFixed(2);
  const fmtEscrow = (Number(taxEscrow) || 0).toFixed(2);

  const lenderKey = String(lenderRowIndex);
  const escrowKey = String(escrowTaxRowIndex);

  closingCostsMeta[lenderKey] = {
    ...(closingCostsMeta[lenderKey] ?? {}),
    value: fmtLender,
    total: fmtLender,
    Cash: fmtLender,
    type: "Flat Fee",
  };

  closingCostsMeta[escrowKey] = {
    ...(closingCostsMeta[escrowKey] ?? {}),
    value: fmtEscrow,
    total: fmtEscrow,
    Cash: fmtEscrow,
    type: "Flat Fee",
  };

  return {
    ...prev,
    closingCostsMeta,
  };
}
